import OAuthButton from 'shared/components/atoms/OAuthButton/OAuthButton';

export default OAuthButton;
